(function() { 'use strict';

  // Const
  // -----

  var mediaQueries = [
    {
      "smallMobile": 480,
      "mobile": 800,
      "tablet": {
        "landscape": 1024,
        "portrait": 768
      },
      "smallNotebook": 1200,
      "notebook": 1400
    }
  ][0];

  window.SMALL_MOBILE_WIDTH = mediaQueries.smallMobile;
  window.MOBILE_WIDTH = mediaQueries.mobile;
  window.PORTRAIT_TABLET_WIDTH = mediaQueries.tablet.portrait;
  window.TABLET_WIDTH = mediaQueries.tablet.landscape;
  window.SMALL_NOTEBOOK_WIDTH = mediaQueries.smallNotebook;
  window.NOTEBOOK_WIDTH = mediaQueries.notebook;

  window.HEADER_HEIGHT = $('.header').height();

  // selectors
  window.$WINDOW = $(window);
  window.$DOCUMENT = $(document);
  window.$HTML = $(document.documentElement);
  window.$BODY = $(document.body);

  // tosrus default settings
  window.TOSRUS_DEFAULTS = {
    buttons: {
      next: true,
      prev: true
    },

    keys: {
      prev: 37,
      next: 39,
      close: 27
    },

    wrapper: {
      onClick: 'close'
    }
  };


  // Helpers
  // -------

  window.WINDOW_WIDTH = window.innerWidth || $WINDOW.width();
  window.WINDOW_HEIGHT = $WINDOW.height();
  $WINDOW.resize(function() {
    WINDOW_WIDTH = window.innerWidth || $WINDOW.width();
    WINDOW_HEIGHT = $WINDOW.height();
  });

  window.IS_DESKTOP_WIDTH = function() {
    return WINDOW_WIDTH > NOTEBOOK_WIDTH;
  };
  window.IS_NOTEBOOK_WIDTH = function() {
    return ( WINDOW_WIDTH > SMALL_NOTEBOOK_WIDTH && WINDOW_WIDTH <= NOTEBOOK_WIDTH );
  };
  window.IS_SMALL_NOTEBOOK_WIDTH = function() {
    return ( WINDOW_WIDTH > TABLET_WIDTH && WINDOW_WIDTH <= SMALL_NOTEBOOK_WIDTH );
  };
  window.IS_TABLET_WIDTH = function() {
    return ( WINDOW_WIDTH >= PORTRAIT_TABLET_WIDTH && WINDOW_WIDTH <= TABLET_WIDTH );
  };
  window.IS_MOBILE_WIDTH = function() {
    return WINDOW_WIDTH <= MOBILE_WIDTH;
  };
  window.IS_SMALL_MOBILE_WIDTH = function() {
    return WINDOW_WIDTH <= SMALL_MOBILE_WIDTH;
  };
  window.IS_TOUCH_DEVICE = 'ontouchstart' in document;


  // Masked input
  // ------------

  if (IS_DESKTOP) {
    $('input[type="date"]').attr('type', 'text');

    // Phone
    $('input[type="tel"]').mask('+7 (999) 999-99-99', {
      autoclear: false
    });

    // Date
    $('.js-date-mask').mask('99/99/9999', {
      placeholder: 'дд.мм.гггг',
      autoclear: false
    });

    // Time
    $('.js-time-mask').mask('99:99', {
      placeholder: 'чч:мм',
      autoclear: false
    });
  }

  // Overlay loader
  // --------------

  // open popup
  $DOCUMENT.on('click.overlay-open', '.js-overlay', function(e) {
    e.preventDefault();

    var $popup = $(this).attr('href');

    $.overlayLoader(true, {
      node: $popup,
      hideSelector: '.js-popup-close'
    });
  });

  $DOCUMENT.on('click', '.js-works-popup-close', function(e) {
    e.preventDefault();

    $.overlayLoader(false, {
      node: $('#works')
    });
  });

  $('.success-popup .js-popup-close').click(function() {
    $(this).closest('.popup').fadeOut();
  });

  // autofocus
  $DOCUMENT.on('overlayLoaderShow', function(e, $node) {
    $node.find('.js-autofocus-inp').focus();
  });


  // Selectric
  // ---------

  // init selectric
  $DOCUMENT.on('initSelectric yiiListViewUpdated', function() {
    $('select').selectric({
      disableOnMobile: false,
      nativeOnMobile: true
    });
  }).trigger('initSelectric');


  // Checkboxes
  // ----------

  $('.checkbox input').on('change initCheckboxes', function() {
    var $inp = $(this),
        $label = $inp.closest('.checkbox');

    if ( $inp.prop('checked') ) {
      $label.addClass('checked');
    } else {
      $label.removeClass('checked');
    }
  }).trigger('initCheckboxes');


  // Radio buttons
  // ----------

  $('.radio input').on('change initRadio', function() {
    var $inp = $(this),
        $group = $('[name="' + $inp.attr('name') + '"]'),
        $labels = $group.closest('.radio'),
        $selectedItem = $labels.find('input').filter(':checked').closest('.radio');

    $labels.removeClass('checked');
    $selectedItem.addClass('checked');
  }).trigger('initRadio');


  // File input
  // ----------

  $('.fileinp input').change(function() {
    var $this = $(this);
    $this.closest('.fileinp').find('.chosen-file').text( $this.val() );
  });


  // Scroll to
  // ---------

  $DOCUMENT.on('click.expand', '.js-expand', function() {
    var $blockToExpand = $( $(this).data('expand') );

    $blockToExpand.stop(true, true).fadeIn();

    if ( $blockToExpand.hasClass('faq-content') ) {
      $('.js-toggle-faq').addClass('active');
    }
  });

  $DOCUMENT.on('click', '.js-close-overlay', function(e) {
    $.overlayLoader(false, {
      node: $('#works')
    })
  });

  $DOCUMENT.on('click.scroll-to', '.js-scroll-to', function(e) {
    e.preventDefault();

    var $lnk = $(this);
    var $elemToScroll = $($lnk.attr('href'));
    var speed = $lnk.data('speed') || 150;
    var offset = $lnk.data('offset') == 0 ? 0 : $lnk.data('offset') || -HEADER_HEIGHT;

    $WINDOW.scrollTo($elemToScroll, {duration: speed, offset: offset});
  });

  $DOCUMENT.on('click.scroll-to', '.js-scroll-to-registration', function(e) {
    e.preventDefault();

    var $lnk = $(this);
    var $elemToScroll = $($lnk.attr('href'));
    var speed = $lnk.data('speed') || 150;
    var offset = $lnk.data('offset') == 0 ? 0 : $lnk.data('offset') || -HEADER_HEIGHT;

    if ( $elemToScroll.length ) {
      $WINDOW.scrollTo($elemToScroll, {duration: speed, offset: offset});
    } else {
      document.location = document.location.protocol + '//' + document.location.host + '/#registration';
    }
  });


  // Menus
  // -----

  (function() {
    var $menus = $('.js-menu');

    if (IS_DESKTOP) {
      $menus.on('mouseenter.js-menu', 'li', function() {
        var $this = $(this);
        clearTimeout($this.data('hoverTimeout'));
        $this.addClass('is-hovered');
      });

      $menus.on('mouseleave.js-menu', 'li', function() {
        var $this = $(this);
        $this.data('hoverTimeout', setTimeout(function() {
          $this.removeClass('is-hovered');
        }, 200));
      });
    }

    if (IS_MOBILE) {
      $menus.on('click.js-m-menu', 'a', function(e) {
        e.preventDefault();

        var $anchor = $(this);
        var $parent = $anchor.parent();

        var hasDropdown = $parent.hasClass('has-dropdown');
        var isHovered = $parent.hasClass('is-hovered');

        $parent.siblings().removeClass('is-hovered');

        if (!hasDropdown) {
          location.href = $anchor.attr('href');
        } else {
          if (isHovered) {
            location.href = $anchor.attr('href');
          } else {
            $parent.addClass('is-hovered');
          }
        }
      });
    }

    $('.js-header-menu-link').click(function() {
      var $this = $(this),
          $menu = $this.closest('.js-header-menu');

      $menu.toggleClass('active');
    });

    $('.js-header-menu a').click(function() {
      var $this = $(this);
      $this.closest('.js-header-menu').removeClass('active');

      // Перекидываем с внутренних страниц на главную из меню
      if ( document.location.pathname != '/' && !$this.closest('.menu-socials').length ) {
        document.location = $this.attr('href');
      }
    });
  }());


  // Tabs
  // ----

  $('.js-tabs > .tabs-nav li a').click(function(e) {
    e.preventDefault();

    var $this = $(this);
    var $panel = $( $this.attr('href') );

    if ( $this.closest('li').hasClass('disabled') ) return;

    $this.closest('li').addClass('active').siblings().removeClass('active');
    $panel.closest('.js-tabs').find('> .tabs-content > .tabs-panel').hide();
    $panel.fadeIn();
  });


  // Galleries
  // ---------

  // init tosrus static gallery
  $('.js-gallery').each(function() {
    $(this).find('.js-gallery-item').tosrus(TOSRUS_DEFAULTS);
  });


  // Запуск видео в попапе
  if ( !IS_MOBILE ) {
    $('.js-video-link').each(function() {
      $(this).tosrus( $.extend(TOSRUS_DEFAULTS, { wrapper: {classes: 'fullslide-video'} }) )
        .bind('opening.tos', function() {
          var $iframe = $(this).find('iframe'),
              src = $iframe.attr('src');

          $iframe.attr('src', src + '&autoplay=1');
        });
    });
  }

  // Rotators
  // --------

  $('.js-slideshow').each(function() {
    var $this = $(this);

    var tos = $this.tosrus({
      effect: 'slide',
      slides: {
        visible: 1
      },
      autoplay: {
        play: true,
        timeout: 7500
      },
      infinite: true,
      pagination: {
        add: true
      }
    });
  });


  // Scrolling to top
  // ----------------

  if ( !IS_MOBILE_WIDTH() ) {
    var goTopBtn = $('<div class="go-top-btn"></div>');
    goTopBtn.click(function() {
      $WINDOW.scrollTo(0, 200);
    });
    $WINDOW.scroll(function() {
      var scrollTop = $WINDOW.scrollTop();
      if ( scrollTop > 0 ) {
        goTopBtn.addClass('visible');
      } else {
        goTopBtn.removeClass('visible');
      }
    });
    $BODY.append( goTopBtn );
  }


  // Inview slide detect
  // -------------------

  var $inviewSlides = $('.js-inview');
  if ( !IS_MOBILE_WIDTH() ) {
    $inviewSlides.each(function() {
      var $this = $(this);
      $this.bind('inview', function(event, isInView, visiblePartX, visiblePartY) {
        if (isInView) {
          // element is now visible in the viewport
          $this.addClass('inview');
          if (visiblePartY == 'top') {
            // top part of element is visible
            $this.removeClass('inview-bottom')
          } else if (visiblePartY == 'bottom') {
            // bottom part of element is visible
            $this.addClass('inview-bottom')
          } else {
            // whole part of element is visible
            $this.addClass('inview-bottom')
          }
        } else {
          // element has gone out of viewport
          $this.removeClass('inview inview-bottom');
        }
      });
    });
  }


  // Intro parallax
  // --------------

  var $introSlide = $('.js-intro-slide'),
      $introSpots = $('.js-intro-spots'),
      $prizeSlide = $('.js-prize-slide'),
      $prizeSpots_1 = $('.js-prize-spots-1'),
      $prizeSpots_2 = $('.js-prize-spots-2'),
      $ratingSlide = $('.js-rating-slide'),
      $ratingSpots_1 = $('.js-rating-spots-1'),
      $ratingSpots_2 = $('.js-rating-spots-2'),
      // $stagesSlide = $('.js-stages-slide'),
      $judgesSlide = $('.js-judges-slide'),
      $judgesLine = $('.js-judges-bg-line'),
      $faqSlide = $('.js-faq-slide'),
      $faqLine_1 = $('.js-faq-bg-line-1'),
      $faqLine_2 = $('.js-faq-bg-line-2'),
      $rulesSlide = $('.js-rules-slide'),
      $rulesSpots = $('.js-rules-spots'),
      $rulesLine = $('.js-rules-bg-line'),
      $registrationSlide = $('#registration'),
      $worksSlide = $('#works'),
      $newsSlide = $('#news');

  if ( $introSlide.length ) {
    var introHeight = $introSlide.height(),
        introTop = $introSlide.offset().top;

    var currentPos = $WINDOW.scrollTop() + WINDOW_HEIGHT - introTop,
      adjuster = 100 / introHeight,
      bgTop = currentPos ? 100 - currentPos * adjuster : 100,
      bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

    $introSlide.css('background-position', bgPos);

    $introSpots.css('margin-bottom', bgTop * 2);
  }

  if ( $prizeSlide.length ) {
    var prizeHeight = $prizeSlide.height(),
        prizeTop = $prizeSlide.offset().top;
  }

  if ( $ratingSlide.length ) {
    var ratingHeight = $ratingSlide.height(),
        ratingTop = $ratingSlide.offset().top;
  }

  // if ( $stagesSlide.length ) {
  //   var stagesHeight = $stagesSlide.height(),
  //       stagesTop = $stagesSlide.offset().top;
  // }

  if ( $judgesSlide.length ) {
    var judgesHeight = $judgesSlide.height(),
        judgesTop = $judgesSlide.offset().top;
  }

  if ( $faqSlide.length ) {
    $('#faq-content').show();
    var faqHeight = $faqSlide.height(),
        faqTop = $faqSlide.offset().top;
    $('#faq-content').hide();
  }

  if ( $rulesSlide.length ) {
    $('#rules').show();
    var rulesHeight = $rulesSlide.height(),
        rulesTop = $rulesSlide.offset().top;
    $('#rules').hide();
  }

  $WINDOW.resize(function() {
    if ( $introSlide.length ) {
      introHeight = $introSlide.height();
      introTop = $introSlide.offset().top;
    }

    if ( $prizeSlide.length ) {
      prizeHeight = $prizeSlide.height();
      prizeTop = $prizeSlide.offset().top;
    }

    if ( $ratingSlide.length ) {
      ratingHeight = $ratingSlide.height();
      ratingTop = $ratingSlide.offset().top;
    }

    // if ( $stagesSlide.length ) {
    //   stagesHeight = $stagesSlide.height();
    //   stagesTop = $stagesSlide.offset().top;
    // }

    if ( $judgesSlide.length ) {
      judgesHeight = $judgesSlide.height();
      judgesTop = $judgesSlide.offset().top;
    }

    if ( $faqSlide.length ) {
      $('#faq-content').show();
      faqHeight = $faqSlide.height();
      faqTop = $faqSlide.offset().top;
      $('#faq-content').hide();
    }

    if ( $rulesSlide.length ) {
      $('#rules').show();
      rulesHeight = $rulesSlide.height();
      rulesTop = $rulesSlide.offset().top;
      $('#rules').hide();
    }
  });

  $WINDOW.scroll(function() {
    var scrollTop = $WINDOW.scrollTop();

    if ( $introSlide.hasClass('inview') ) {
      var currentPos = scrollTop + WINDOW_HEIGHT - introTop,
          adjuster = 100 / introHeight,
          bgTop = currentPos ? 100 - currentPos * adjuster : 100,
          bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

      $introSlide.css('background-position', bgPos);

      $introSpots.css('margin-bottom', bgTop * 2);
    }

    if ( $prizeSlide.hasClass('inview') ) {
      var currentPos = scrollTop + WINDOW_HEIGHT - prizeTop,
          adjuster = 100 / prizeHeight,
          bgTop = currentPos ? 100 - currentPos * adjuster : 100,
          bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

      $prizeSpots_1.css('margin-top', bgTop * 2);
      $prizeSpots_2.css('margin-top', bgTop * 1.5);
    }

    if ( $ratingSlide.hasClass('inview') ) {
      var currentPos = scrollTop + WINDOW_HEIGHT - ratingTop,
          adjuster = 100 / ratingHeight,
          bgTop = currentPos ? 100 - currentPos * adjuster : 100,
          bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

      $ratingSpots_1.css('margin-top', bgTop * 2);
      $ratingSpots_2.css('margin-top', bgTop * 1.5);
    }

    // if ( $stagesSlide.hasClass('inview') ) {
    //   var currentPos = scrollTop + WINDOW_HEIGHT - stagesTop,
    //       adjuster = 100 / stagesHeight,
    //       bgTop = currentPos ? 100 - currentPos * adjuster : 100,
    //       bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

    //   $stagesSpots.css('margin-top', bgTop * 2);
    // }

    if ( $judgesSlide.hasClass('inview') ) {
      var currentPos = scrollTop + WINDOW_HEIGHT - judgesTop,
          adjuster = 100 / judgesHeight,
          bgTop = currentPos ? 100 - currentPos * adjuster : 100,
          bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

      $judgesLine.css('margin-top', bgTop * 10);
    }

    if ( $faqSlide.hasClass('inview') ) {
      var currentPos = scrollTop + WINDOW_HEIGHT - faqTop,
          adjuster = 100 / faqHeight,
          bgTop = currentPos ? 100 - currentPos * adjuster : 100,
          bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

      $faqLine_1.css('margin-top', bgTop * 10);
      $faqLine_2.css('margin-top', bgTop * 12);
    }

    if ( $rulesSlide.hasClass('inview') ) {
      var currentPos = scrollTop + WINDOW_HEIGHT - rulesTop,
          adjuster = 100 / rulesHeight,
          bgTop = currentPos ? 100 - currentPos * adjuster : 100,
          bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

      $rulesLine.css('margin-top', bgTop * 15);
      $rulesSpots.css('margin-top', bgTop * 2);
    }
  });

  $('#cube-info .slide').each(function() {
    var $slide = $(this),
        slideTop = $slide.offset().top,
        slideHeight = $slide.height(),
        $leftSpots = $slide.find('.js-left-spots'),
        $rightSpots = $slide.find('.js-right-spots');

    $WINDOW.scroll(function() {
      var scrollTop = $WINDOW.scrollTop();

      if ( $slide.hasClass('inview') ) {
        var currentPos = scrollTop + WINDOW_HEIGHT - slideTop,
            adjuster = 100 / slideHeight,
            bgTop = currentPos ? 100 - currentPos * adjuster : 100,
            bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

        $leftSpots.css('margin-top', bgTop * 2);
        $rightSpots.css('margin-bottom', bgTop * 1.5);
      }
    });
  });

  $('#ripcurl-info .slide').each(function() {
    var $slide = $(this),
        slideTop = $slide.offset().top,
        slideHeight = $slide.height(),
        $rightSpots_1 = $slide.find('.js-right-spots-1'),
        $rightSpots_2 = $slide.find('.js-right-spots-2');

    $WINDOW.scroll(function() {
      var scrollTop = $WINDOW.scrollTop();

      if ( $slide.hasClass('inview') ) {
        var currentPos = scrollTop + WINDOW_HEIGHT - slideTop,
            adjuster = 100 / slideHeight,
            bgTop = currentPos ? 100 - currentPos * adjuster : 100,
            bgPos = '50% ' + (bgTop > 0 ? bgTop : 0) + '%';

        $rightSpots_1.css('margin-top', bgTop * 2);
        $rightSpots_2.css('margin-top', bgTop * 1.5);
      }
    });
  });

  var commonController = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 'onLeave',
        }
      });

  // if ( $prizeSlide.length ) {
  //   if ( !IS_SMALL_MOBILE_WIDTH() ) {
  //     // var prizeSceneDuration = $('#prize').height() - WINDOW_HEIGHT;
  //     var prizeSceneDuration = $('#prize').height() * .5;
  //     $WINDOW.resize(function() {
  //       // prizeSceneDuration = $('#prize').height() - WINDOW_HEIGHT;
  //       prizeSceneDuration = $('#prize').height() * .5;
  //     });

  //     new ScrollMagic.Scene({
  //           triggerElement: '#prize',
  //           duration: prizeSceneDuration
  //         })
  //         .setPin('.prize-caption')
  //         .addTo(commonController);
  //   }
  // }

  if ( $judgesSlide.length ) {
    var judgesSceneDuration = $('#judges').outerHeight() - WINDOW_HEIGHT;
    $WINDOW.resize(function() {
      judgesSceneDuration = $('#judges').height() - WINDOW_HEIGHT;
    });

    new ScrollMagic.Scene({
          triggerElement: '#judges',
          duration: judgesSceneDuration
        })
        .setPin('.js-judges-bg')
        .addTo(commonController);
  }

  if ( $registrationSlide.length ) {
    var registrationSceneDuration = $('#registration').outerHeight() - WINDOW_HEIGHT;
    $WINDOW.resize(function() {
      registrationSceneDuration = $('#registration').height() - WINDOW_HEIGHT;
    });

    new ScrollMagic.Scene({
          triggerElement: '#registration',
          duration: registrationSceneDuration
        })
        .setPin('.js-registration-bg')
        .addTo(commonController);
  }

  if ( $faqSlide.length ) {
    $('#faq-content').show();
    var faqSceneDuration = $('#faq').outerHeight() - WINDOW_HEIGHT;
    $('#faq-content').hide();
    $WINDOW.resize(function() {
      $('#faq-content').show();
      faqSceneDuration = $('#faq').height() - WINDOW_HEIGHT;
      $('#faq-content').hide();
    });

    new ScrollMagic.Scene({
          triggerElement: '#faq',
          duration: faqSceneDuration
        })
        .setPin('.js-faq-bg')
        .addTo(commonController);
  }

  if ( $newsSlide.length ) {
    var newsSceneDuration = $('#news').outerHeight();// - WINDOW_HEIGHT;
    $WINDOW.resize(function() {
      newsSceneDuration = $('#news').height();// - WINDOW_HEIGHT;
    });

    new ScrollMagic.Scene({
          triggerElement: '#news',
          duration: newsSceneDuration
        })
        .setPin('.js-news-bg')
        .addTo(commonController);
  }

  if ( $worksSlide.length ) {
    var worksSceneDuration = $('#works').outerHeight() - WINDOW_HEIGHT;
    $WINDOW.resize(function() {
      worksSceneDuration = $('#works').height() - WINDOW_HEIGHT;
    });

    new ScrollMagic.Scene({
          triggerElement: '#works',
          duration: worksSceneDuration
        })
        .setPin('.js-works-bg')
        .addTo(commonController);
  }

  if ( IS_DESKTOP ) {
    var startPoint = [0, 0];
    if ( $('.participant-section').length ) {
      $('body').on('mouseenter', function(e) {
        startPoint = [e.screenX, e.screenY];
      }).on('mousemove', function(e) {
        var position = [startPoint[0] - e.screenX, startPoint[1] - e.screenY];
        if ( position[0] > 0 ) {
          position[0] *= -1;
        }
        // if ( position[1] < 0 ) {
        //   position[1] *= -1;
        // }
        $('.js-snow-left').css({
          left: position[0] * .05,
          // top: position[1] * .1
        });
        $('.js-snow-right').css({
          right: position[0] * .1,
          // top: position[1] * .25
        });
      });
    }
  }


  $('.js-toggle-rules').click(function() {
    $('#rules').stop(true, true).fadeToggle();
  });

  $('.js-toggle-faq').click(function() {
    $(this).toggleClass('active');
    $('#faq-content').stop(true, true).fadeToggle();
    $('.js-faq-slide').toggleClass('is-collapsed');
    $WINDOW.scrollTo($('#faq'), {offset: -HEADER_HEIGHT, duration: 150});
  });


  // Instagram widget
  // ----------------

  window.initInstagram = function(token) {
    var picsLimit = 12;

    if ( IS_SMALL_MOBILE_WIDTH() ) {
      picsLimit = 4;
    }

    $WINDOW.resize(function() {
      if ( IS_SMALL_MOBILE_WIDTH() ) {
        picsLimit = 4;
      } else {
        picsLimit = 12;
      }
    });

    var feed = new Instafeed({
          clientId: '9f5c4436b4774771a9ccd7db93cb73f2',
          get: 'user',
          userId: 4212707123,
          accessToken: token,
          limit: picsLimit,
          resolution: 'low_resolution',
          template: '<a href="{{link}}" target="_blank"><img src="{{image}}" alt="" /></a>',
          after: function() {
            var newPage = $('<div class="instapage"></div>'),
              newPics = $('#instafeed a:gt(' + (picsLimit - 1) + ')').detach();
            newPage.append( newPics );
            if ( newPage.find('a').length ) {
              $('.instawidget').append( newPage );
            }
          }
        });
        feed.run();

    setTimeout(function() {
      feed.next();
    }, 1000);

    $('.inst-next-page').click(function(e) {
      e.preventDefault();
      feed.next();
      var activePage = $('.instapage.active'),
        pageWidth = $('.small-wrapper').width(),
        widget = $('.instawidget'),
        currentPosition = parseInt( widget.css('left'), 10 );
      if ( $('.instapage.active').next().length ) {
        $('.instapage.active').removeClass('active').next().addClass('active');
        widget.css( 'left', currentPosition - pageWidth );
      }
      if ( $('.instapage.active').prev().length ) {
        $('.inst-prev-page').removeClass('disabled');
      }
      if ( feed.hasNext() || $('.instapage.active').next().length ) {
        $('.inst-next-page').removeClass('disabled');
      } else {
        $('.inst-next-page').addClass('disabled');
      }
    });

    $('.inst-prev-page').click(function(e) {
      e.preventDefault();
      var activePage = $('.instapage.active'),
        pageWidth = $('.small-wrapper').width(),
        widget = $('.instawidget'),
        currentPosition = parseInt( widget.css('left'), 10 );
      if ( $('.instapage.active').prev().length ) {
        $('.instapage.active').removeClass('active').prev().addClass('active');
        widget.css( 'left', currentPosition + pageWidth );
      }
      if ( !$('.instapage.active').prev().length ) {
        $('.inst-prev-page').addClass('disabled');
      }
      if ( $('.instapage.active').next().length ) {
        $('.inst-next-page').removeClass('disabled');
      }
    });
  }


  // Tooltips
  // --------

  $('.js-tooltip-anchor').click(function() {
    var $this = $(this),
        $tooltip = $this.closest('.js-tooltip'),
        $tooltipBody = $tooltip.find('.js-tooltip-body');

    $tooltipBody.stop(true, true).fadeToggle();

    $BODY.on('click.tooltip', function(e) {
      console.log(e.target);
      if ( !$(e.target).closest('.js-tooltip').length ) {
        $tooltipBody.stop(true, true).fadeOut();
        $BODY.off('click.tooltip');
      }
    });
  });

  $('.js-tooltip-close').click(function() {
    $(this).closest('.js-tooltip').find('.js-tooltip-body').stop(true, true).fadeOut();
    $BODY.off('click.tooltip');
  });


  // Timer
  // -----

  var $timer = $('.js-timer');
  if ( $timer.length ) {
    var startDate = new Date( $timer.data('start') );

    if ( !startDate ) return;

    var currentDate = new Date(),
        difference = startDate - currentDate,
        days = Math.floor( difference / 1000 / 60 / 60 / 24 ) || 0,
        hours = Math.floor( (difference - days * 24 * 60 * 60 * 1000) / 1000 / 60 / 60 ) || 0,
        minutes = Math.floor( (difference - days * 24 * 60 * 60 * 1000 - hours * 60 * 60 * 1000) / 1000 / 60 ) || 0,
        seconds = Math.floor( (difference - days * 24 * 60 * 60 * 1000 - hours * 60 * 60 * 1000 - minutes * 60 * 1000) / 1000) || 0,
        $days = $('.js-timer-days'),
        $hours = $('.js-timer-hours'),
        $minutes = $('.js-timer-minutes'),
        $seconds = $('.js-timer-seconds');

    function setDate() {
      $days.text( days < 10 ? '0' + days : days );
      $hours.text( hours < 10 ? '0' + hours : hours );
      $minutes.text( minutes < 10 ? '0' + minutes : minutes );
      $seconds.text( seconds < 10 ? '0' + seconds : seconds );
    }

    setDate();

    if ( days == 0 && hours == 0 && minutes == 0 && seconds == 0 ) return;

    var timerInterval = setInterval(function() {
      seconds -= 1;
      if ( seconds < 0 ) {
        seconds = 59;
        minutes -= 1;
        if ( minutes < 0 ) {
          minutes = 59;
          hours -= 1;
          if ( hours < 0 ) {
            hours = 23;
            days -= 1;
            if ( days < 0 ) {
              days = 0;
              clearInterval( timerInterval );
            }
          }
        }
      }

      setDate();
    }, 1000);

  }

})();
